import { AddPaymentAccountsApi } from "@/features/accounts/payment/scraping/services/add-accounts-api";
import { AddPaymentAccountsRequestModel } from "@/features/accounts/payment/scraping/services/add-accounts-model";

/// MoneyLook 口座追加処理
export class AddPaymentAccountsService {
  private addPaymentAccountsApi = new AddPaymentAccountsApi();

  /**
   * MoneyLook 口座追加API実行
   */
  public async addPaymentAccounts(param: AddPaymentAccountsRequestModel) {
    return await this.addPaymentAccountsApi.addPaymentAccounts(param);
  }
}
